import script from "./wanchengrichang.vue?vue&type=script&setup=true&lang=js"
export * from "./wanchengrichang.vue?vue&type=script&setup=true&lang=js"

import "./wanchengrichang.vue?vue&type=style&index=0&id=06567c41&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06567c41"]])

export default __exports__